import React, { FC } from "react";
import { Button } from "@primer/react";
import { GridRow } from "@getregistered/greg-editors";

export interface ResetButtonPrimerProps {
  selectedItems?: GridRow[];
  showResetAll?: boolean;
  onClick: () => void;
}

export const ResetButtonPrimer: FC<ResetButtonPrimerProps> = ({
  selectedItems,
  showResetAll,
  onClick,
}) => {
  const handleResetAllClick = (e) => {
    if (confirm("Are you sure? This will reset badge print status for the whole event")) {
      onClick();
    }
  };

  const handleResetSelectedClick = () => {
    const count = selectedItems?.length ?? 0;
    if (
      confirm(
        `Reset ${count} selected badge${count === 1 ? "" : "s"}? This clears the printed status and removes the print history for ${count === 1 ? "this registration" : "these registrations"}.`
      )
    ) {
      onClick();
    }
  };

  if (selectedItems !== undefined && selectedItems.length > 0) {
    return (
      <Button
        onClick={handleResetSelectedClick}
        variant="danger"
        size="medium"
      >
        Reset {selectedItems.length} Selected
      </Button>
    );
  }
  
  if (showResetAll) {
    return (
      <Button 
        onClick={handleResetAllClick} 
        variant="danger"
        size="medium"
      >
        Reset All
      </Button>
    );
  }
  
  return null;
}; 